"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * MouseUp Component helps handle mouse up event
 * this can trigger mouse up event after mousedown happens in editor
 * even mouse up is happening outside editor
 */
var MouseUpPlugin = /** @class */ (function () {
    function MouseUpPlugin() {
        var _this = this;
        this.onMouseUp = function (rawEvent) {
            if (_this.editor) {
                _this.removeMouseUpEventListener();
                _this.editor.triggerPluginEvent(5 /* MouseUp */, {
                    rawEvent: rawEvent,
                });
            }
        };
    }
    MouseUpPlugin.prototype.getName = function () {
        return 'MouseUp';
    };
    MouseUpPlugin.prototype.initialize = function (editor) {
        this.editor = editor;
    };
    MouseUpPlugin.prototype.dispose = function () {
        this.removeMouseUpEventListener();
        this.editor = null;
    };
    /**
     * Handle events triggered from editor
     * @param event PluginEvent object
     */
    MouseUpPlugin.prototype.onPluginEvent = function (event) {
        if (event.eventType == 4 /* MouseDown */ && !this.mouseUpEventListerAdded) {
            this.editor
                .getDocument()
                .addEventListener('mouseup', this.onMouseUp, true /*setCapture*/);
            this.mouseUpEventListerAdded = true;
        }
    };
    MouseUpPlugin.prototype.removeMouseUpEventListener = function () {
        if (this.mouseUpEventListerAdded) {
            this.mouseUpEventListerAdded = false;
            this.editor.getDocument().removeEventListener('mouseup', this.onMouseUp, true);
        }
    };
    return MouseUpPlugin;
}());
exports.default = MouseUpPlugin;
//# sourceMappingURL=MouseUpPlugin.js.map